// @flow

import React, {type Node, Children, useRef, useState} from 'react';
import {UncontrolledTooltip} from 'reactstrap';

import {type OverlayPlacementType} from 'app/general/overlays';

type Props = {|
  className?: string,
  hide?: boolean,
  children: Node,
  tooltip?: Node,
  delay?: number | {|show?: number, hide?: number|},
  placement?: OverlayPlacementType,
|};

export function LazyTooltip({
  hide = false,
  children,
  tooltip,
  ...other
}: Props) {
  /*
    This intends to be a lazy tooltip component, which wouldn't run any
    reactstrap tooltip code until user hover over the target
    */
  const childrenRef = useRef<HTMLElement | null>(null);
  const [mounted, setMounted] = useState<boolean>(false);
  const singleChildren = Children.only(children);

  function saveRef(ref: HTMLElement | null) {
    childrenRef.current = ref;

    /* respect original ref attribute in children */
    const originalRef = singleChildren.ref;
    if (originalRef != null) {
      if (Object.prototype.hasOwnProperty.call(originalRef, 'current')) {
        originalRef.current = ref;
      } else if (typeof originalRef === 'function') {
        originalRef(ref);
      }
    }
  }

  return (
    <>
      {React.cloneElement(singleChildren, {
        ref: saveRef,
        onMouseEnter: () => setMounted(true),
      })}
      {tooltip != null && !hide && mounted ? (
        <UncontrolledTooltip
          className="fade in out"
          delay={250}
          autohide={false}
          target={childrenRef.current}
          {...other}
        >
          {tooltip}
        </UncontrolledTooltip>
      ) : null}
    </>
  );
}
